// extracted by mini-css-extract-plugin
export var form = "_56-0";